mpangoApp.factory('Mbudget',['$http', function ($http) {
	return{
		getItems : function  () {
			return $http.get('index.php/api/getitems');
		},
		postItem : function(item) {
			return $http({
				method: 'POST',
				url: 'index.php/api/postitem',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':item}
			
			});
		},
		updateItem : function(itemdata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updateitem',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':itemdata,'formname':formname}
			});
		},
	}
}]);
